import VerivoxRatingsClass  from './../App/VerivoxRatings';
import ModalClass           from './../App/Modal';
import infiniteScroll       from './infiniteScroll';

export default verivoxRatings => {
    let $urlElem = $('[data-rating-url]');

    if ($urlElem.length < 1) {
        return false;
    }

    let url = $urlElem.data('rating-url');
    let VerivoxRating = new VerivoxRatingsClass();
    let Modal = new ModalClass();

    $('body').on('click', '.get-ratings', event => {
        let $item = $(event.currentTarget);
        let provider = $item.data('provider');
        let providerName = $item.data('provider-name');
        let totalReviews = $item.data('total');
        let $totalRatings = $item.parent().prev().clone();

        $totalRatings.find('.star-ratings').wrapAll('<div class="row"></div>');
        $totalRatings.find('.star-ratings.big').removeClass('small-12').removeClass('column').wrap('<div class="column small-6"></div>');
        $totalRatings.find('.ratings.row').removeClass('row').addClass('column small-12');
        $totalRatings.find('.star-ratings:not(.big)')
            .wrapAll('<div class="columns small-6"></div>')
            .removeClass('column')
            .removeClass('small-12')
            .each((key, item) => {
                let $rate = $(item);
                let $caption = $rate.find('.silent-caption').detach();

                $caption.insertAfter($rate);
        });


        VerivoxRating.setProvider(provider)
                    .setUrl(url)
                    .setPage(1);

        VerivoxRating.request(request => {
            let ratingObj = request?.ratings?.rating;

            if (!ratingObj || (Array.isArray(ratingObj) && ratingObj.length < 1)) {
                return false;
            }

            VerivoxRating.setTotalReviews(totalReviews);

            let ratingHtml = VerivoxRating.prepareModalContent(ratingObj, providerName);

            Modal.setContent(ratingHtml);
            Modal.open(true);

            $('.modal .total-review-result').html($totalRatings.html());

            infiniteScroll($('.modal #scroll'), VerivoxRating);
        }, request => {
            console.warn(request);
        });

        return false;
    });
};